





















































import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';

import { DailyLoadExpectedFile } from '@/api/dashboard/DailyLoadExpectedFile';
import { DailyLoadFileTypes } from '@/api/dashboard/DailyLoadFileTypes';

@Component({})
export default class DailyLoadExpectedFilesDialog extends Vue {
  @Prop({ default: [] }) expectedFiles!: DailyLoadExpectedFile[];

  @Prop({ default: null }) fiId!: number | null;

  @Prop({ default: null }) fiName!: string | null;

  @Prop({ default: null }) coreProcessingDate!: string| null;

  showDialog: boolean = false;

	headers: {text: string, value: string, sortable?: boolean, }[] = [
	  { text: 'Processing Status', value: 'serviceName', sortable: false },
	  { text: 'Expected File', value: 'fileName', sortable: false },
	  { text: 'Sumo Query', value: 'sumoLink', sortable: false },
	  { text: 'Is IB Login Pre-Transform', value: 'isIbLoginPreTransform', sortable: false },
	];

	options:any = {
	  sortBy: ['serviceName'],
	  sortDesc: [false],
	};

	footerProps:any = {
	  'items-per-page-options': [10, 5],
	};

	dataTableRecords: {
		serviceName: string,
		fileName: string,
		sumoLink: string,
		isIbLoginPreTransform: boolean,
		id: number,
	}[] = [];

	closeDialog() {
	  this.showDialog = false;
	}

	@Watch('expectedFiles')
	onExpectedFilesChanged() {
	  this.showDialog = true;
	  return true;
	}

	getDataTableRecords = () => {
	  this.dataTableRecords.splice(0, this.dataTableRecords.length);
	  for (let i = 0; i < this.expectedFiles.length; i++) {
	    const expectedFile = this.expectedFiles[i];
	    this.dataTableRecords.push({
	      serviceName: DailyLoadFileTypes.get(expectedFile.fileType)!,
	      fileName: this.splitFileName(expectedFile.objectKey)!,
	      sumoLink: expectedFile.searchLink,
	      isIbLoginPreTransform: expectedFile.ibloginPreTransform,
	      id: i,
	    });
	  }
	  return this.dataTableRecords;
	}

	splitFileName = (objectKey: string | null) => (!objectKey ? '' : objectKey.split('/').pop())
}

